import $api from "@/frontend/shared/api/axios";

type TPostSearchCompanies = {
  page: number;
  limit: number;
  name: string;
};

export async function postSearchCompetitorCompanies(props: TPostSearchCompanies) {
  const { page = 1, limit, name } = props;

  const requestBody = {
    page,
    limit: limit || 10,
    name: name ? name : undefined
  };

  const res = await $api.post(`/search/companies`, requestBody);

  return res.data.data;
}
